import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { useCustomizeLayoutContext } from './customize-layout-provider';

import { messages } from './messages';
import style from './layout-selector.module.less';

import type { LayoutMode } from './customize-layout-provider.d';

const LAYOUT_MODES: Record<string, LayoutMode> = {
  ONE_COLUMN: 1,
  TWO_COLUMNS: 2,
  THREE_COLUMNS: 3,
};

type LayoutIconProps = {
  isActive: boolean;
  layout: LayoutMode;
  onClick: (layout: LayoutMode) => void;
};

const LayoutIcon = ({ layout, isActive, onClick }: LayoutIconProps) => {
  const { formatMessage } = useIntl();
  const iconClass = classnames(style['layout-icon'], {
    [style.active]: isActive,
  });

  return (
    <Button
      ariaLabel={formatMessage(messages.columnLayoutLabel, { layout })}
      className={iconClass}
      onClick={() => onClick(layout)}
      theme='unstyled'
    >
      <div className={style['icon-grid']}>
        {Array.from({ length: layout }).map((_, index) => (
          <div key={index} className={style['column-bar']} />
        ))}
      </div>
    </Button>
  );
};

export const LayoutSelector = () => {
  const { layoutMode, onColumnLayoutChanged } = useCustomizeLayoutContext();
  return (
    <div className={style['layout-selector']}>
      <LayoutIcon isActive={layoutMode === LAYOUT_MODES.ONE_COLUMN} layout={LAYOUT_MODES.ONE_COLUMN} onClick={onColumnLayoutChanged} />
      <LayoutIcon isActive={layoutMode === LAYOUT_MODES.TWO_COLUMNS} layout={LAYOUT_MODES.TWO_COLUMNS} onClick={onColumnLayoutChanged} />
      <LayoutIcon
        isActive={layoutMode === LAYOUT_MODES.THREE_COLUMNS}
        layout={LAYOUT_MODES.THREE_COLUMNS}
        onClick={onColumnLayoutChanged}
      />
    </div>
  );
};
